import React from 'react';
import './card.styles.scss';
import { Card as ReactBootstrapCard } from 'react-bootstrap';

interface Props {
  children: React.ReactNode;
  className?: string;
  hidden?: boolean;
}

const Card: React.FC<Props> = ({ children, className, hidden }) => {
  return (
    <ReactBootstrapCard className={`card-component ${className}`} hidden={hidden}>
      <ReactBootstrapCard.Body>{children}</ReactBootstrapCard.Body>
    </ReactBootstrapCard>
  );
};

export default Card;
